import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UserService } from 'src/app/shared/user.service';
import { ContractTemplate } from '../../shared/contract-template.model';
import { ContractService } from '../../shared/contract.service';
import { Templates } from '../../shared/templates.model';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Observable, startWith, map } from 'rxjs';

@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.css']
})
export class TemplateComponent implements OnInit {

  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('contractInput') contractInput!: ElementRef<HTMLInputElement>;
  @ViewChild('filterInput') filterInput!: ElementRef<HTMLInputElement>;

  displayedColumns: string[] = ['Template Name', 'Description', 'Version', 'Created By', 'Last Updated', 'Action'];
  contractTypes: any;
  filteredOptions: Observable<string[]>;
  selectedContractType = new FormControl('');
  isNotFound: boolean = false;
  contractTypeId: number = null;
  isLoading: boolean = true;
  dataLoading: boolean = false;
  templates: any = [];
  downloadLoading: { [key: string]: boolean } = {};

  constructor(public contractService: ContractService, public userService: UserService, public toast: ToastrService) { }

  async ngOnInit() {
    this.dataLoading = true;
    await this.contractService.getContractTypes().then((res: any) => {
      this.contractTypes = res;
    })

    await this.contractService.getAllTemplates().then((allTemplates: any) =>{
      allTemplates.forEach((templates: any) => {
        templates.updatedDate = moment(templates.updatedDate).format('lll')
      });
      this.templates = allTemplates;
      this.dataSource.data = allTemplates;
    });

    if (this.sort) {
      this.dataSource.sort = this.sort;
      this.dataSource.sort.active = 'Last Updated';
      this.dataSource.sort.direction = 'desc';
      this.customSortData({
        active: 'Last Updated',
        direction: 'desc'
      } as Sort);
    }

    if (this.paginator) {
      this.paginator.firstPage();
    }

    this.isLoading = false;
    this.dataLoading = false;

    if (this.contractTypes) {
      this.filteredOptions = this.selectedContractType.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value || ''))
      );
    }
  }

  private _filter(value: string): any[] {
    this.isNotFound = false;
    const filterValue = value.toLowerCase();
    const results = this.contractTypes.filter(option => option.name.toLowerCase().includes(filterValue));
    if (results.length === 0)
      this.isNotFound = true

    return results;
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  onInputChange(value: string) {
    this.filteredOptions = this.selectedContractType.valueChanges.pipe(
      startWith(value),
      map(val => this._filter(val || ''))
    );
  }

  clearField() {
    this.dataSource.filter = '';
    this.selectedContractType.setValue('');
    this.contractInput.nativeElement.value = '';
    this.filterInput.nativeElement.value = '';
    this.contractTypeId = null;
    this.dataSource.data = this.templates;
  }

  async onContractTypeSelect(event) {
    this.isLoading = true;
    this.dataSource.data = [];
    this.filterInput.nativeElement.value = '';
    this.selectedContractType.setValue(event.option.value.name);
    this.contractTypeId = event.option.value.contractTypeId;

    if (this.contractTypes) {
      this.filteredOptions = this.selectedContractType.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value || ''))
      );
    }

    this.getTemplates();
  }

  async getTemplates() {
    await this.contractService.getTemplates2(this.contractTypeId).then((allTemplates: any) => {
      allTemplates.forEach((templates: any) => {
        templates.updatedDate = moment(templates.updatedDate).format('lll')
      });
      this.dataSource.data = allTemplates;
    });

    if (this.sort) {
      this.dataSource.sort = this.sort;
      this.dataSource.sort.active = 'Last Updated';
      this.dataSource.sort.direction = 'desc';
      this.customSortData({
        active: 'Last Updated',
        direction: 'desc'
      } as Sort);
    }

    if (this.paginator) {
      this.paginator.firstPage();
    }

    this.isLoading = false;
  }

  downloadTemplate(templateId) {

    this.downloadLoading[templateId] = true;
    this.contractService.downloadTemplate(templateId);

    setTimeout(() => {
      this.downloadLoading[templateId] = false;
      this.toast.success('Template Downloaded Sucessfully!', '');
    }, 2000);
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  customSortData(event: Sort) {
    const data = this.dataSource.data.slice();
    if (!event.active || event.direction === '') {
      this.dataSource.data = data;
      return;
    }

    this.dataSource.data = data.sort((a, b) => {
      const valueA = (a[event.active] || '').toString().toLowerCase();
      const valueB = (b[event.active] || '').toString().toLowerCase();

      return this.compare(valueA, valueB, event.direction === 'asc');
    });

    // If pagination is present, reset to the first page after sorting
    if (this.paginator) {
      this.paginator.firstPage();
    }
  }


  compare(a: string, b: string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

}
